<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
            <h5 class="m-0" v-translate>Website Branding was updated!</h5>
          </b-alert>
          <b-card>
            <h1 v-translate>Website Branding</h1>
            <b-form @submit.prevent="updateEcosystem">
              <b-row>
                <b-col>
                  <b-form-row>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Public Name</label>
                      <div class="input-group">
                        <b-form-input v-model="ecosystem.branding.name" type="text" required />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Help Website URL</label>
                      <div class="input-group">
                        <b-form-input v-model="ecosystem.front_config.universe.helpUrl" type="text" />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Help Email</label>
                      <div class="input-group">
                        <b-form-input v-model="ecosystem.branding.help_email" type="email" required />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Sales Email</label>
                      <div class="input-group">
                        <b-form-input v-model="ecosystem.front_config.universe.salesEmail" type="email" required />
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Logo for colored backgrounds</label>
                      <div class="mb-3" v-if="ecosystem.front_config.universe.logo">
                        <b-img :src="ecosystem.front_config.universe.logo" class="logo-img d-inline-block" blank-color="#777" alt="img" />
                        <b-button size="sm" v-b-modal.modalUploadLogo class="d-inline-block">
                          <translate>Change Logo</translate>
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button size="sm" v-b-modal.modalUploadLogo class="d-inline-block">
                          <translate>Add Logo</translate>
                        </b-button>
                      </div>
                      <b-modal id="modalUploadLogo" ref="modalUploadLogo" :hide-footer="true">
                        <div slot="modal-title" v-translate>Change Logo</div>
                        <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                        <profile-picture-uploader @updateProfileImage="ecosystem.front_config.universe.logo = $event; $refs.modalUploadLogo.hide();" @error="$refs.modalUploadLogo.hide();" />
                      </b-modal>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Logo for white backgrounds</label>
                      <div class="mb-3" v-if="ecosystem.front_config.universe.logoLogin">
                        <b-img :src="ecosystem.front_config.universe.logoLogin" class="logo-img d-inline-block" blank-color="#777" alt="img" />
                        <b-button size="sm" v-b-modal.modalUploadLogoLogin class="d-inline-block">
                          <translate>Change Logo</translate>
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button size="sm" v-b-modal.modalUploadLogoLogin class="d-inline-block">
                          <translate>Add Logo</translate>
                        </b-button>
                      </div>
                      <b-modal id="modalUploadLogoLogin" ref="modalUploadLogoLogin" :hide-footer="true">
                        <div slot="modal-title" v-translate>Change Logo</div>
                        <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                        <profile-picture-uploader @updateProfileImage="ecosystem.branding.logo = ecosystem.front_config.universe.logoLogin = $event; $refs.modalUploadLogoLogin.hide();" @error="$refs.modalUploadLogoLogin.hide();" />
                      </b-modal>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Logo for labels</label>
                      <div class="mb-3" v-if="ecosystem.front_config.universe.logoLabel">
                        <b-img :src="ecosystem.front_config.universe.logoLabel" class="logo-img d-inline-block" blank-color="#777" alt="img" />
                        <b-button size="sm" v-b-modal.modalUploadLogoLabel class="d-inline-block">
                          <translate>Change Logo</translate>
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button size="sm" v-b-modal.modalUploadLogoLabel class="d-inline-block">
                          <translate>Add Logo</translate>
                        </b-button>
                      </div>
                      <b-modal id="modalUploadLogoLabel" ref="modalUploadLogoLabel" :hide-footer="true">
                        <div slot="modal-title" v-translate>Change Logo</div>
                        <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                        <profile-picture-uploader @updateProfileImage="ecosystem.branding.logoLabel = ecosystem.front_config.universe.logoLabel = $event; $refs.modalUploadLogoLabel.hide();" @error="$refs.modalUploadLogoLabel.hide();" />
                      </b-modal>
                    </div>
                    <div class="form-group col-12">
                      <label for="change-status" v-translate>Dominant color for Login Page</label>
                      <b-form-group>
                        <b-form-radio v-model="ecosystem.front_config.universe.bgLogin" :value="null"><span><div style="width: 30px; height: 1.8em" :class="ecosystem.front_config.universe.theme + '-primary'"></div></span></b-form-radio>
                        <b-form-radio v-model="ecosystem.front_config.universe.bgLogin" value="invert"><span><div style="width: 30px; height: 1.8em" :class="ecosystem.front_config.universe.theme + '-secondary'"></div></span></b-form-radio>
                      </b-form-group>
                    </div>
                  </b-form-row>

                  <div class="form-group row form-actions mt-5">
                    <div class="col-12">
                      <b-button variant="secondary" size="lg" type="submit" v-translate>Save Changes</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <h3 v-translate>Dashboard Color Scheme</h3>
                  <b-form-group>
                    <b-form-select v-model="ecosystem.front_config.universe.theme" :options="Array.from(Array(11), (_, x) => { return {text: this.$gettextInterpolate(this.$gettext('Scheme %{number}'), {number: x}), value: 't' + x} })"></b-form-select>
                  </b-form-group>
                  <div id="theme-preview">
                    <div class="container">
                      <div class="browser-header">
                        <div class="gfg left">
                          <div class="browser-button close"></div>
                          <div class="browser-button minimize"></div>
                          <div class="browser-button expand"></div>
                        </div>

                        <div class="gfg middle">
                          <input type="text" :value="ecosystem.branding.dashboard_url" disabled />
                        </div>
                        <div class="gfg right">
                          <div style="float: right">
                            <span class="bar"></span>
                            <span class="bar"></span>
                            <span class="bar"></span>
                          </div>
                        </div>
                      </div>

                      <div class="body">
                        <div class="dashboard-header" :class="ecosystem.front_config.universe.theme + '-primary'">
                          <div class="site-name">
                            <span v-if="ecosystem.front_config.universe.logo">
                              <img :src="ecosystem.front_config.universe.logo" alt="Logo">
                            </span>
                            <span v-else>{{ecosystem.front_config.universe.siteName}}</span>
                          </div>
                          <div class="navlink"></div>
                          <div class="navlink"></div>
                          <div class="navlink"></div>
                          <div class="navlink"></div>
                          <div class="navlink"></div>
                          <div class="profile"></div>
                        </div>
                        <div class="dashboard-content">
                          <div class="card search">
                            <div class="skeleton title"></div>
                            <div class="skeleton input"></div>
                            <div class="skeleton input-button " :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                          </div>
                          <div class="my-2">
                            <div class="skeleton button button-lg float-right" :class="ecosystem.front_config.universe.theme + '-secondary'"></div>
                            <div class="skeleton button button-lg" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                          </div>
                          <div class="card shipping">
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                              <div class="skeleton text"></div>
                              <div class="skeleton text"></div>
                              <div class="skeleton button" :class="ecosystem.front_config.universe.theme + '-secondary'"></div>
                            </div>
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton text muted"></div>
                            </div>
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton button" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                            </div>
                            <div class="w-24 d-inline-block">
                              <div class="skeleton button button-lg" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                            </div>
                          </div>
                          <div class="card shipping">
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                              <div class="skeleton text"></div>
                              <div class="skeleton text"></div>
                              <div class="skeleton button" :class="ecosystem.front_config.universe.theme + '-secondary'"></div>
                            </div>
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton text muted"></div>
                            </div>
                            <div class="w-24 d-inline-block pr-1">
                              <div class="skeleton title muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton text muted"></div>
                              <div class="skeleton button" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                            </div>
                            <div class="w-24 d-inline-block">
                              <div class="skeleton button button-lg" :class="ecosystem.front_config.universe.theme + '-primary'"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ProfilePictureUploader from '@/components/ProfilePictureUploader'

export default {
  name: 'ViewBranding',
  components: {
    ProfilePictureUploader
  },
  data() {
    return {
      ecosystem: {
        branding: {
          name: '',
          help_email: '',
          logo: '',
          logoLabel: ''
        },
        front_config: {
          name: '',
          help_email: '',
          universe: {
            siteName: '',
            theme: '',
            logo: '',
            logoLogin: '',
            helpEmail: '',
            salesEmail: '',
            helpUrl: ''
          }
        }
      },
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  watch: {
    ecosystem: {
      deep: true,
      handler(newValue) {
        if (!this.ecosystem.front_config.universe) {
          this.ecosystem.front_config.universe = {
            siteName: '',
            theme: '',
            logo: '',
            logoLogin: '',
            helpEmail: '',
            salesEmail: '',
            helpUrl: ''
          }
        }
        this.ecosystem.front_config.universe.siteName = this.ecosystem.front_config.name = newValue.branding.name
        this.ecosystem.front_config.universe.helpEmail = this.ecosystem.front_config.help_email = newValue.branding.help_email
      }
    }
  },
  mounted() {
    this.getEcosystem()
  },
  methods: {
    getEcosystem() {
      this.ecosystem = {
        ...this.ecosystem,
        ...(this.$ecosystem.front_config ? this.$ecosystem : {
          ...this.$ecosystem,
          front_config: {
            name: '',
            help_email: '',
            universe: {
              siteName: '',
              theme: '',
              logo: '',
              logoLogin: '',
              helpEmail: '',
              salesEmail: '',
              helpUrl: ''
            }
          }
        })
      }
    },
    updateEcosystem() {
      if (confirm(this.$gettext('Are your sure you want to UPDATE the Website Branding?'))) {
        delete this.ecosystem.name
        this.$http.patch(this.$appConfig.api.baseUrl + 'ecosystems/' + this.ecosystem.id, this.ecosystem)
          .then(response => {
            this.$ecosystem = response.body
            this.$universe = response.body.front_config && response.body.front_config.universe ? response.body.front_config.universe : {
              siteName: 'Moova',
              logo: '/static/img/moova.svg',
              logoLogin: '/static/img/moova-blue.svg',
              theme: 'moova',
              helpUrl: 'http://ayuda.moova.io/',
              helpEmail: 'help@moova.io',
              salesEmail: 'comercial@moova.io',
              googleRegister: true,
              terms: 'https://moova.io/terminos-y-condiciones/',
              privacy: 'https://moova.io/politica-de-privacidad/'
            }
            this.$store.dispatch('setUniverse', this.$universe)
            this.ecosystem = {...this.$ecosystem}
            this.showAlert()
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-img {
  max-width: 100px;
  max-height: 100px;
  padding: 5px;
  &:hover {
    background-color: #ddd;
  }
}
#theme-preview {
  .container {
    padding: 0;
    border: 2px solid #bdc3c7;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .browser-header {
    padding: 10px;
    background: #f1f1f1;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    &:after {
      content: "";
      display: table;
      clear: both;
    }
  }

  .browser-button {
    float: none;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    margin-right: 6px;
    display: inline-block;
    opacity: 1;
    &.close {
      background: #D5635D;
    }
    &.minimize {
      background: #DA5;
    }
    &.expand {
      background: #76B24F;
    }
  }

  input[type=text] {
    width: 100%;
    border-radius: 3px;
    border: none;
    background-color: white;
    margin-top: -8px;
    height: 25px;
    color: gray;
    padding: 5px;
  }

  .gfg {
    float: left;
  }

  .middle {
    width: 75%;
    position: relative;
  }

  .left {
    width: 15%;
  }

  .right {
    width: 10%;
  }

  /* Address bar design */
  .bar {
    width: 15px;
    height: 3px;
    margin: 3px 0;
    display: block;
    background-color: #aaa;
    border-radius: 6px;
  }

  .body {
    padding: 0;
    .w-24 {
      width: 24%;
    }
    .muted {
      background-color: #ddd !important;
    }
    .dashboard-header {
      width: 100%;
      .site-name {
        display: inline-block !important;
        margin: 1px 20px 1px 5px;
        font-size: 8px;
        color: #fff;
        img {
          max-width: 100px;
          max-height: 15px;
        }
      }
      .navlink {
        display: inline-block;
        width: 25px;
        height: 3px;
        margin: 2px 0;
        background-color: #fff;
        border-radius: 6px;
        margin-right: 15px;
      }
      .profile {
        float: right;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        margin: 4px 5px;
        background-color: #fff;
      }
    }
    .dashboard-content {
      padding: 15px 10%;
      background-color: #fff;
      .card {
        border: 0;
        border-radius: 3px;
        box-shadow: 0 15px 50px 0 rgba(0,0,0,.15);
        padding: 15px;
        margin-bottom: 5px;
        display: block;
        &.shipping > div {
          vertical-align: top;
        }
        &.shipping > div:last-child {
          vertical-align: middle;
        }
        .skeleton {
          &.title {
            max-width: 100px;
            height: 10px;
            background: #ccc;
            border-radius: 3px;
            margin-bottom: 5px;
          }
          &.input {
            background-color: #f1f1f1;
            border-bottom: 1px solid #aaa;
            height: 10px;
            display: inline-block;
            width: 40%;
          }
          &.input-button {
            display: inline-block;
            width: 30px;
            height: 10px;
            border-radius: 0 6px 6px 0;
          }
          &.text {
            max-width: 100px;
            height: 6px;
            background: #ccc;
            border-radius: 2px;
            margin-bottom: 2px;
          }
        }
      }
      .button {
        width: 50px;
        height: 9px;
        border-radius: 10px;
      }
      .button-lg {
        height: 12px;
      }
    }
  }
}
.t0 {
  &-primary {
    background-color: #4fa0ff !important;
  }
  &-secondary {
    background-color: #28d0b6 !important;
  }
}
.t1 {
  &-primary {
    background-color: #127475 !important;
  }
  &-secondary {
    background-color: #f2542d !important;
  }
}
.t2 {
  &-primary {
    background-color: #072448 !important;
  }
  &-secondary {
    background-color: #54d2d2 !important;
  }
}
.t3 {
  &-primary {
    background-color: #2b2d42 !important;
  }
  &-secondary {
    background-color: #ef233c !important;
  }
}
.t4 {
  &-primary {
    background-color: #101314 !important;
  }
  &-secondary {
    background-color: #efc825 !important;
  }
}
.t5 {
  &-primary {
    background-color: #2f408b !important;
  }
  &-secondary {
    background-color: #cad302 !important;
  }
}
.t6 {
  &-primary {
    background-color: #8bc53f !important;
  }
  &-secondary {
    background-color: #f16522 !important;
  }
}
.t7 {
  &-primary {
    background-color: #ff0092 !important;
  }
  &-secondary {
    background-color: #ffdd00 !important;
  }
}
.t8 {
  &-primary {
    background-color: #ef476f !important;
  }
  &-secondary {
    background-color: #118ab2 !important;
  }
}
.t9 {
  &-primary {
    background-color: #ff6b35 !important;
  }
  &-secondary {
    background-color: #2ec4b6 !important;
  }
}
.t10 {
  &-primary {
    background-color: #361d32 !important;
  }
  &-secondary {
    background-color: #f55951 !important;
  }
}
</style>
